import IEnum from '../interfaces/IEnum';

export const StepTypes: IEnum = {
    translations:{
        0: {
            name: 'lang.shared.personalData'
        },
        1: {
            name: 'lang.shared.address'
        },
        2: {
            name: 'lang.inscriptions.turnNotificationStep',
            alterName:'lang.shared.notification'
        },
        3: {
            name: 'lang.shared.capabilityData'
        },
        4: {
            name: 'lang.shared.payExemption'
        },
        5: {
            name: 'lang.inscriptions.aceptAndFinish'
        },
        6: {
        },
        7: {
            name: 'lang.shared.authorizations'
        },
        8: {
            name: 'lang.shared.taxPayment'
        },
        10: {
            name: 'lang.shared.creditableExams'
        },
        11: {
            name: 'lang.inscriptions.aceptAndFinish'
        }
    },
    enum: {
        PERSONALDATA: 0,
        ADDRESS: 1,
        CONTACT: 2,
        CAPABILITY: 3,
        PAYEXEMTION: 4,
        ACCEPTANDFINISH: 5,
        AUTHORIZATIONS: 7,
        TAXPAYMENT: 8,
        CREDITABLEEXAMS: 10,
        LEGAL: 11
    }
    
};
